import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import Tag from "@/components/base/Tag";

const categoryTone: Record<string, "primary" | "accent" | "secondary"> = {
  新闻: "primary",
  活动: "accent",
  公告: "secondary",
};

export default function NewsCard({ item, layout = "vertical" }: { item: NewsItem; layout?: "vertical" | "horizontal" }) {
  if (layout === "horizontal") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3.5 transition-all duration-300 hover:border-primary-300"
      >
        <div className="h-24 w-32 shrink-0 overflow-hidden rounded-md sm:w-40">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} - 朝桐光影视动态`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="mb-2 flex items-center gap-2">
            <Tag tone={categoryTone[item.category]}>{item.category}</Tag>
            <span className="text-xs text-foreground-500">{item.date}</span>
          </div>
          <h3 className="line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
            {item.title}
          </h3>
          <p className="mt-1.5 hidden line-clamp-2 text-sm text-foreground-600 sm:block">{item.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300"
    >
      <div className="w-full overflow-hidden" style={{ aspectRatio: "8 / 5" }}>
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 朝桐光影视动态`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex items-center gap-2">
          <Tag tone={categoryTone[item.category]}>{item.category}</Tag>
          <span className="text-xs text-foreground-500">{item.date}</span>
        </div>
        <h3 className="line-clamp-2 text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-accent-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
        </span>
      </div>
    </Link>
  );
}